import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {editProjektStart} from '../../store/actions/projekt-edit.actions';
import {addProjektStart} from '../../store/actions/projekt-add.actions';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import * as moment from 'moment';
import {select, Store} from '@ngrx/store';
import {ProjektState} from '../../store/reducer/projektverwaltung.reducer';
import {MatDialog} from '@angular/material/dialog';
import {getFilteredProjektStart} from '../../store/actions/getFilteredProjekt.actions';
import {loadProjekteStart} from '../../store/actions/getAllProjekte.actions';
import {loadNodesStart} from '../../store/actions/getAllNodes.actions';

@Component({
    selector: 'app-projekt-filter',
    templateUrl: './projekt-filter.component.html',
    styleUrls: ['./projekt-filter.component.scss'],
})
export class ProjektFilterComponent {

  constructor(private store: Store<{ projektverwaltung: ProjektState }>, public dialog: MatDialog) {
  }

  public filterForm = new FormGroup({
    suche: new FormControl(''),
    datumVon: new FormControl(''),
    datumBis: new FormControl(''),
    archiv: new FormControl(''),
  });


  public wandler(datum: any): any {
    // tslint:disable-next-line:triple-equals
    if (datum == undefined){
      return null;
    }
    const dwD = datum.toLocaleString( 'en-US', {timezone: 'utc'} );
    const backendDat = moment(dwD).format('YYYY-MM-DD');
    return backendDat;
  }

  public search(checked: boolean): void{
    if(checked){
      this.store.dispatch(loadNodesStart({archiv: 1}));
    }
    else{
      this.store.dispatch(loadNodesStart({archiv: 0}));
    }

   /* let searchString = '';

    // Suche ausgefüllt
    if (this.filterForm.value.suche){
      searchString += 'search';
    }
    // Datum ausgefüllt
    if (this.filterForm.value.datumBis && this.filterForm.value.datumVon){
      searchString += 'beideDatum';
      this.filterForm.value.datumVon = this.wandler(this.filterForm.value.datumVon);
      this.filterForm.value.datumBis = this.wandler(this.filterForm.value.datumBis);
    }
    else if (this.filterForm.value.datumBis){
      searchString += 'bisDatum';
      this.filterForm.value.datumBis = this.wandler(this.filterForm.value.datumBis);
    }
    else if (this.filterForm.value.datumVon){
      searchString += 'vonDatum';
      this.filterForm.value.datumVon = this.wandler(this.filterForm.value.datumVon);
    }

    if (this.filterForm.value.archiv){
        searchString += 'check';
    }
    if (searchString.length === 0 ){
      this.store.dispatch(loadNodesStart());
    }
    else if (searchString === '.'){
      return;
    }
    else {
      this.store.dispatch(getFilteredProjektStart({string: searchString, item: this.filterForm.value}));
    }*/
  }
}
